__turbopack_context__.v({
  "agentHeader": "page-module__uV0gyW__agentHeader",
  "agentIcon": "page-module__uV0gyW__agentIcon",
  "breadcrumbChevron": "page-module__uV0gyW__breadcrumbChevron",
  "breadcrumbLink": "page-module__uV0gyW__breadcrumbLink",
  "breadcrumbText": "page-module__uV0gyW__breadcrumbText",
  "chatBubbleAgent": "page-module__uV0gyW__chatBubbleAgent",
  "chatBubbleUser": "page-module__uV0gyW__chatBubbleUser",
  "chatContent": "page-module__uV0gyW__chatContent",
  "contactAvatar": "page-module__uV0gyW__contactAvatar",
  "contactName": "page-module__uV0gyW__contactName",
  "dynamicIsland": "page-module__uV0gyW__dynamicIsland",
  "header": "page-module__uV0gyW__header",
  "headerButton": "page-module__uV0gyW__headerButton",
  "infoCard": "page-module__uV0gyW__infoCard",
  "iphoneFrame": "page-module__uV0gyW__iphoneFrame",
  "messagesHeader": "page-module__uV0gyW__messagesHeader",
  "page": "page-module__uV0gyW__page",
  "phoneWrapper": "page-module__uV0gyW__phoneWrapper",
  "showcaseContainer": "page-module__uV0gyW__showcaseContainer",
  "showcaseContent": "page-module__uV0gyW__showcaseContent",
  "showcaseGradient": "page-module__uV0gyW__showcaseGradient",
  "statusBar": "page-module__uV0gyW__statusBar",
  "statusTime": "page-module__uV0gyW__statusTime",
  "text": "page-module__uV0gyW__text",
  "userBubbleText": "page-module__uV0gyW__userBubbleText",
});
